(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-food-calculator"] && !Shopify.designMode) return;
  try {
    
const PPFeedingMath = (() => {
  function split(values, locks, index, requested) {
    const result=values.slice(), others=values.map((v,i)=>i).filter(i=>i!==index&&!locks[i]);
    if(locks[index]||!others.length)return result;
    const fixed=values.reduce((n,v,i)=>n+(i!==index&&locks[i]?v:0),0);
    result[index]=Math.max(0,Math.min(100-fixed,Math.round(Number(requested)||0)));
    let left=100-fixed-result[index], old=others.reduce((n,i)=>n+values[i],0), used=0;
    others.forEach((i,n)=>{const v=n===others.length-1?left-used:Math.min(left-used,Math.round(left*(old?values[i]/old:1/others.length)));result[i]=v;used+=v;});
    return result;
  }
  function number(v,min,max,key) { const n=Number(v);if(v===''||!Number.isFinite(n)||n<min||n>max)throw new Error(key);return n; }
  function calculate(d,foods,breed) {
    const months=number(d.months,2,300,'age_error');
    const puppy=d.growing||months<12;
    if(d.special)throw new Error('special_error');
    if(d.condition==='over'||d.condition==='under')throw new Error('condition_error');
    const range=breed && breed[d.sex];
    const midpoint=range?(range[0]+range[1])/2:null;
    if(puppy&&d.currentUnknown)throw new Error('puppy_weight_error');
    if(d.currentUnknown&&!midpoint)throw new Error('breed_error');
    let current=d.currentUnknown?midpoint:number(d.current,.5,120,'weight_error');
    let ideal;
    if(puppy)ideal=current;
    else if(d.idealUnknown){ideal=midpoint||current;}
    else ideal=number(d.ideal,.5,120,'weight_error');
    if(!puppy&&!d.currentUnknown&&!d.idealUnknown&&Math.abs(current-ideal)/ideal>.10)throw new Error('weight_goal_error');
    const weight=puppy?current:(d.idealUnknown&&!d.currentUnknown?current:ideal);
    const factors={low:95,medium:110,active:125,working:162.5};
    if(!factors[d.activity])throw new Error('activity_error');
    let energy=puppy?70*Math.pow(weight,.75)*(months<4?3:2):factors[d.activity]*Math.pow(weight,.75);
    const treats=number(d.treats,0,10,'treat_error');
    if(!foods.length||Math.abs(foods.reduce((n,f)=>n+Number(f.percent),0)-100)>.001)throw new Error('split_error');
    const meals=energy*(1-treats/100);
    const result=foods.map(f=>{
      const share=number(f.percent,0,100,'split_error')/100;
      if(f.type==='raw'){
        const weeks=months*365.25/12/7;
        let rate=puppy?(weeks<10?9:weeks<16?7.5:weeks<20?6.5:weeks<24?5.5:weeks<36?4.5:weeks<56?3.5:3):({low:2,medium:2.5,active:3,working:3}[d.activity]);
        return {...f,grams:weight*1000*rate/100*share*(1-treats/100),basis:'raw',rate};
      }
      if(f.method==='guide')return {...f,grams:number(f.guide,1,10000,'guide_error')*share*(1-treats/100),basis:'guide'};
      const kcal100=number(f.kcal100,20,900,'calorie_error');
      return {...f,grams:meals*share*100/kcal100,basis:f.manual?'manual':'recorded',kcal100};
    });
    return {weight,current,ideal,energy,treatCalories:energy*treats/100,puppy,estimatedWeight:d.currentUnknown,assumedIdeal:d.idealUnknown,range,rows:result};
  }
  return {split,calculate};
})();


(() => {
 const start=root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const data=JSON.parse(root.querySelector('[data-data]').textContent),t=JSON.parse(root.querySelector('[data-text]').textContent);
  const $=s=>root.querySelector(s),$$=s=>Array.from(root.querySelectorAll(s));
  let step=0,types=[],shares=[],locks=[],foodState={};
  const panels=$$('[data-step]');
  const el=(tag,text,cls)=>{const n=document.createElement(tag);if(text!==undefined)n.textContent=text;if(cls)n.className=cls;return n;};
  const field=(host,label,node)=>{const l=el('label',undefined,'pp-feed-field');l.append(el('span',label),node);host.append(l);return node;};
  const option=(select,value,label)=>{const o=el('option',label);o.value=value;select.append(o);};
  const select=(host,label,items,value)=>{const s=el('select');items.forEach(([v,l])=>option(s,v,l));s.value=value||items[0][0];field(host,label,s);return s;};
  const input=(host,label,type,value)=>{const n=el('input');n.type=type;n.value=value||'';if(type==='number'){n.min='0';n.step='any';n.inputMode='decimal';}field(host,label,n);return n;};
  const say=key=>{ $('[data-error]').textContent=t[key]||key; };
  function show(n){step=n;panels.forEach((p,i)=>p.hidden=i!==n);$('[data-progress]').textContent=t['step_'+n];$('[data-back]').hidden=n===0;$('[data-next]').hidden=n===5;$('[data-next]').textContent=n===4?t.calculate:t.next;say('');$('[data-progress]').focus();}
  function buildFoods(){const host=$('[data-foods]');host.replaceChildren();types.filter(k=>k!=='raw').forEach(type=>{
   const state=foodState[type]||(foodState[type]={id:'',brand:'',recipe:'',method:'calories',calories:'',unit:'100',guide:''});
   const box=el('div',undefined,'pp-feed-card');box.append(el('h3',t[type]));host.append(box);
   const products=data.foods.filter(f=>f.type===type);
   const product=select(box,t.which_food,[['',t.choose],...products.map(p=>[p.id,p.brand+' — '+p.name]),['other',t.other]],state.id);
   const detail=el('div');box.append(detail);
   product.addEventListener('change',()=>{state.id=product.value;state.method='calories';state.calories='';state.guide='';renderDetail();});
   function renderDetail(){detail.replaceChildren();if(!state.id)return;
    const record=products.find(f=>f.id===state.id);
    if(state.id==='other'){
     const brand=select(detail,t.brand,[['',t.choose],...data.brands.map(b=>[b,b]),['unlisted',t.unlisted_brand]],state.brand);
     brand.onchange=()=>{state.brand=brand.value;renderDetail();};
     if(state.brand==='unlisted'){const custom=input(detail,t.brand_name,'text',state.customBrand);custom.oninput=()=>state.customBrand=custom.value;}
     const recipe=input(detail,t.recipe,'text',state.recipe);recipe.oninput=()=>state.recipe=recipe.value;
    }
    if(record&&record.kcal100){detail.append(el('p',t.recorded.replace('{value}',record.kcal100)));const a=el('a',t.view_food);a.href=record.source;a.target='_blank';a.rel='noopener';detail.append(a);}
    const methods=record&&record.kcal100?[['recorded',t.use_recorded],['calories',t.enter_calories],['guide',t.enter_guide]]:[['calories',t.enter_calories],['guide',t.enter_guide]];
    if(record&&record.kcal100&&state.method==='calories'&&!state.calories)state.method='recorded';
    const method=select(detail,t.method,methods,state.method);state.method=method.value;
    const values=el('div');detail.append(values);
    function buildValues(){values.replaceChildren();
     if(state.method==='calories'){
      const cal=input(values,t.calories,'number',state.calories);cal.min='1';cal.oninput=()=>state.calories=cal.value;
      const unit=select(values,t.units,[['100',t.per100],['1000',t.perkg]],state.unit);unit.onchange=()=>state.unit=unit.value;
     }else if(state.method==='guide'){
      values.append(el('p',t.guide_help));const g=input(values,t.guide_amount,'number',state.guide);g.min='1';g.oninput=()=>state.guide=g.value;
     }
    }
    method.onchange=()=>{state.method=method.value;buildValues();};buildValues();
    if(record&&!record.kcal100)detail.append(el('p',t.missing_calories,'pp-feed-note'));
   }renderDetail();
  });
  $('[data-raw-note]').hidden=!types.includes('raw');
 }
 function buildShares(){const host=$('[data-shares]');host.replaceChildren();types.forEach((type,i)=>{
  const box=el('div',undefined,'pp-feed-card');box.append(el('h3',t[type]));host.append(box);
  const r=input(box,t.share_slider.replace('{food}',t[type]),'range',shares[i]);r.min=0;r.max=100;r.step=1;r.dataset.share=i;
  const n=input(box,t.share_number.replace('{food}',t[type]),'number',shares[i]);n.min=0;n.max=100;n.step=1;n.dataset.number=i;
  const l=el('input');l.type='checkbox';l.checked=locks[i];field(box,t.lock,l);l.onchange=()=>{locks[i]=l.checked;syncShares();};
  function change(value){shares=PPFeedingMath.split(shares,locks,i,value);syncShares();}
  r.oninput=()=>change(r.value);n.onchange=()=>change(n.value);
 });syncShares();}
 function syncShares(){types.forEach((type,i)=>{const r=$('[data-share="'+i+'"]'),n=$('[data-number="'+i+'"]');r.value=n.value=shares[i];r.disabled=n.disabled=locks[i]||!locks.some((v,j)=>j!==i&&!v);});$('[data-total]').textContent=t.total.replace('{total}',shares.reduce((a,b)=>a+b,0));}
 const breed=$('[name=breed]');option(breed,'',t.choose);data.breeds.forEach((b,i)=>option(breed,String(i),b.name));option(breed,'other',t.other_breed);
 function weightState(){['current','ideal'].forEach(name=>{$('[name='+name+']').disabled=$('[name='+name+'Unknown]').checked;});const b=data.breeds[breed.value],sex=$('[name=sex]').value,r=b&&b[sex];$('[data-breed-note]').replaceChildren();if(r){const p=el('p',t.breed_reference.replace('{range}',r[0]+'–'+r[1]));const a=el('a',t.breed_source);a.href=b.source;a.target='_blank';a.rel='noopener';$('[data-breed-note]').append(p,a);}else $('[data-breed-note]').textContent=t.no_breed_reference;}
 ['currentUnknown','idealUnknown','breed','sex'].forEach(n=>$('[name='+n+']').addEventListener('change',weightState));weightState();
 function dog(){const v=n=>$('[name='+n+']').value,c=n=>$('[name='+n+']').checked;return {sex:v('sex'),months:Number(v('age'))*(v('ageunit')==='years'?12:1),growing:c('growing'),activity:v('activity'),current:v('current'),ideal:v('ideal'),currentUnknown:c('currentUnknown'),idealUnknown:c('idealUnknown'),treats:v('treats'),condition:v('condition'),special:c('special')};}
 function foods(){return types.map((type,i)=>{if(type==='raw')return {type,name:t.raw,percent:shares[i]};const s=foodState[type],r=data.foods.find(f=>f.id===s.id);return {type,name:r?r.name:(s.recipe||t.other),brand:r?r.brand:(s.brand==='unlisted'?s.customBrand:s.brand),percent:shares[i],method:s.method,guide:s.guide,kcal100:s.method==='recorded'&&r?r.kcal100:Number(s.calories)/(s.unit==='1000'?10:1),manual:s.method!=='recorded'};});}
 function results(){if(!$('[name=complete]').checked)throw new Error('complete_error');const d=dog(),b=data.breeds[breed.value],r=PPFeedingMath.calculate(d,foods(),b),host=$('[data-results]');host.replaceChildren();
  host.append(el('p',t.starting_point,'pp-feed-note'));
  host.append(el('p',t.weight_used.replace('{weight}',r.weight.toFixed(1))));
  if(r.estimatedWeight||r.assumedIdeal)host.append(el('p',r.estimatedWeight?t.estimated_weight:t.assumed_ideal,'pp-feed-note'));
  if(d.condition==='unknown')host.append(el('p',t.condition_unknown));
  if(r.puppy)host.append(el('p',t.puppy_note,'pp-feed-note'));
  r.rows.forEach(row=>{const box=el('article',undefined,'pp-feed-result');box.append(el('h3',row.name),el('strong',t.grams.replace('{grams}',Math.round(row.grams))),el('p',t.share_result.replace('{percent}',row.percent)),el('p',t['basis_'+row.basis]));if(row.kcal100)box.append(el('p',t.recorded.replace('{value}',row.kcal100)));if(row.rate)box.append(el('p',t.raw_rate.replace('{rate}',row.rate)));host.append(box);});
  if(r.treatCalories)host.append(el('p',t.treat_result.replace('{calories}',Math.round(r.treatCalories))));
  host.append(el('p',t.follow_up));show(5);
 }
 $('[data-next]').onclick=()=>{try{
  if(step===0){const next=$$('[name=foodtype]:checked').map(n=>n.value);if(!next.length)throw new Error('food_error');if(next.join()!==types.join()){types=next;shares=types.map((_,i)=>i===types.length-1?100-Math.floor(100/types.length)*(types.length-1):Math.floor(100/types.length));locks=types.map(()=>false);}buildFoods();show(types.every(k=>k==='raw')?(types.length>1?2:3):1);}
  else if(step===1){types.filter(k=>k!=='raw').forEach(type=>{const s=foodState[type];if(!s.id)throw new Error('recipe_error');if(s.id==='other'&&(!s.brand||!s.recipe.trim()||(s.brand==='unlisted'&&!String(s.customBrand||'').trim())))throw new Error('recipe_error');if(s.method==='calories'&&(!(Number(s.calories)>0)))throw new Error('calorie_error');if(s.method==='guide'&&(!(Number(s.guide)>0)))throw new Error('guide_error');});if(types.length>1){buildShares();show(2);}else show(3);}
  else if(step===2)show(3);
  else if(step===3){if(!breed.value||!$('[name=sex]').value||!$('[name=activity]').value||!$('[name=condition]').value)throw new Error('dog_error');const d=dog();if(!Number.isFinite(d.months)||d.months<2||d.months>300)throw new Error('age_error');if(d.special)throw new Error('special_error');weightState();show(4);}
  else results();
 }catch(e){say(e.message);}};
 $('[data-back]').onclick=()=>show(step===5?4:step===3?(types.length>1?2:types.includes('raw')?0:1):step===2?1:step-1);
 $('[data-restart]').onclick=()=>show(0);
 show(0);
 };
 document.querySelectorAll('pp-food-calculator').forEach(start);
 document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('pp-food-calculator').forEach(start));
})();


  } catch(e) { console.error(e); }
})();
})();
